import store from '../index';

export const sendAlert = async (alertData) => {
  try {
    const tenant = window.location.hostname.split('.')[0];
    const state = store.getState();
    const userRole = state.app.role?.name;
    const currentUser = state.app.user;
    // SI ES ADMIN, NO ENVIAR ALERTA
    if (userRole === 'admin') {
      console.log('Admin action, no alert needed');
      return { success: true, message: 'Admin action, no alert needed' };
    }

    const response = await fetch(`/api/v1/notifications/alert/${tenant}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...alertData,
        triggeredByRole: userRole,
        currentUser,
      }),
    });

    return await response.json();
  } catch (error) {
    return { success: false, error: error.message };
  }
};
